import client from "./httpClient";
import { SERVER_URL } from "../constants/Api";

const baseUrl = `${SERVER_URL}/self_registration/verify_email_otp`;

export const verify = async ({
  email,
  otpCode,
  accountId,
  type
}) => {
  return await client.post(baseUrl,
    {
      json: {
        email: email, 
        otp_code: otpCode, 
        verification_type: type, 
        account_id: accountId
      }
    }).json(); 
};
